import { defineComponent as n, createBlock as t, openBlock as a, unref as l, mergeProps as d, withCtx as p, createElementVNode as i } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconShareAndroid",
  __name: "IconShareAndroid",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const r = o;
    return (c, e) => (a(), t(l(m), d(r, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        i("path", {
          "fill-rule": "evenodd",
          d: "M12 6a3.75 3.75 0 1 1 1.044 2.596l-3.286 2.076A3.741 3.741 0 0 1 10 12a3.742 3.742 0 0 1-.242 1.328l3.286 2.076a3.75 3.75 0 1 1-.802 1.268l-3.286-2.076a3.75 3.75 0 1 1 0-5.192l3.286-2.076A3.74 3.74 0 0 1 12 6m3.75-2.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5m0 12a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M4 12a2.25 2.25 0 1 1 4.5 0A2.25 2.25 0 0 1 4 12",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
